import { getBackboneWindow } from '../getBackboneWindow'

export const getCurrentBrandSlug = (): string | undefined =>
  getBackboneWindow().OpalMoments?.State?.current_brand_slug
